import React from 'react';
import { ProviderContext } from '.';

// @ts-ignore
export default React.createContext<ProviderContext>();
